document.addEventListener("ra_translate_bar_used", function () {
	const {pum_id} = ra_translate_bar;
	const popup_delay = 1000;

	setTimeout(() => {
		PUM.open(pum_id)
	}, popup_delay);
}, {once: true})
